export const sendGAEvent = (data, dimensions) => {
  const win = window as any;
  if (!win || !win?.gtag) {
    return false;
  }

  const containerId = process.env.REACT_APP_GOOGLE_TAG_ID;
  const { action, category, label } = data;

  win.gtag("event", action, {
    send_to: containerId,
    event_category: category,
    event_label: label,
    ...dimensions,
  });
};
